// extracted by mini-css-extract-plugin
export var actionButton = "_ap-1";
export var actionButtons = "_ap-2";
export var actions = "_ap-0";
export var aiUnread = "_ap-10";
export var alignCenter = "_ap-h";
export var backWrapper = "_ap-3";
export var cellContainer = "_ap-4";
export var checkboxContainer = "_ap-5";
export var contentContainer = "_ap-6";
export var contentHeader = "_ap-8";
export var conversationsTableWrapper = "_ap-s";
export var draftReplyBadgeContainer = "_ap-m";
export var dropdownItem = "_ap-b";
export var dropdownItemsContainer = "_ap-a";
export var dropdownTitle = "_ap-c";
export var errorIcon = "_ap-7";
export var filter = "_ap-d";
export var gray = "_ap-i";
export var headerActionButtons = "_ap-e";
export var headerCheckboxContainer = "_ap-f";
export var icon = "_ap-j";
export var menuContainer = "_ap-k";
export var noMoreTicketsIcon = "_ap-12";
export var noMoreTicketsSubText = "_ap-13";
export var oneLine = "_ap-l";
export var optionsButton = "_ap-n";
export var plus = "_ap-o";
export var portalButtonsWrapper = "_ap-g";
export var red = "_ap-p";
export var scrolledTop = "_ap-9";
export var search = "_ap-q";
export var selectedConversationsCount = "_ap-r";
export var spinner = "_ap-t";
export var strong = "_ap-u";
export var summaryCell = "_ap-v";
export var tableContainer = "_ap-11";
export var tagContainer = "_ap-w";
export var threeDots = "_ap-x";
export var twoLines = "_ap-y";
export var unread = "_ap-z";